// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gmGw","productName":"Table_productName__3UUGW"};